import styled from 'styled-components';
import DollarIcon from '@/assets/mo/Dollar.svg?react';
import MusicIcon from '@/assets/mo/Music.svg?react';

interface Props {
  label: string; // 수정: '지급' | '부지급' → string
  totalFee?: string;
}

const ReviewMetaTag = ({ label, totalFee }: Props) => {
  const isPaid = label.includes('지급');
  const showFee = isPaid && totalFee;

  return (
    <HorizontalWrapper>
      <TagContainer isPaid={isPaid}>
        {isPaid ? <StyledDollarIcon /> : <StyledMusicIcon />}
        <TagText isPaid={isPaid}>{label}</TagText>
      </TagContainer>

      {showFee && (
        <TagContainer isPaid={isPaid}>
          <StyledDollarIcon />
          <TagText isPaid={isPaid}>{Number(totalFee).toLocaleString()}만원</TagText>
        </TagContainer>
      )}
    </HorizontalWrapper>
  );
};

export default ReviewMetaTag;

const HorizontalWrapper = styled.div`
  display: flex;
  gap: 4px; // 또는 8px, spacing 조절
`;

const TagContainer = styled.div<{ isPaid: boolean }>`
  display: flex;
  padding: 4px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 4px;
  background: ${({ isPaid }) => (isPaid ? 'var(--table-BG-table_bg02_hov, #F0F3FE)' : '#FEF0F0')};
`;

const StyledDollarIcon = styled(DollarIcon)`
  width: 16px;
  height: 16px;
`;

const StyledMusicIcon = styled(MusicIcon)`
  width: 16px;
  height: 16px;
`;

const TagText = styled.span<{ isPaid: boolean }>`
  color: ${({ isPaid }) => (isPaid ? '#4C84E3' : '#E34C4C')};
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%;
  letter-spacing: -0.24px;
`;
